import http from '@/utils/request';

/**
 * 查询接口请求数量
 * @param {string} params.analyzeTimeFrom 分析时间自，格式：yyyy-MM-dd
 * @param {string} params.analyzeTimeTo 分析时间止，格式：yyyy-MM-dd
 * @param {string} params.serverName 服务名称，如果是查询服务端维度的数据，该字段必传
 * @param {string} params.source 来源，也代表具体某个应用，如果是查询客户端维度的相关数据，该字段必传
 * @param {string} params.env 应用环境
 */
export const queryApiCount = (params) => http.get({
  url: '/requestAnalyze/queryApiCount',
  params,
});

/**
 * 查询接口请求汇总
 * @param {string} params.requestTimeFrom 请求时间自，格式：yyyy-MM-dd HH:mm:ss
 * @param {string} params.requestTimeTo 请求时间止，格式：yyyy-MM-dd HH:mm:ss
 * @param {string} params.serverName 服务名称，如果是查询服务端维度的数据，该字段必传
 * @param {string} params.source 来源，也代表具体某个应用，如果是查询客户端维度的相关数据，该字段必传
 * @param {string} params.env 应用环境
 */
export const queryApiStat = (params) => http.get({
  url: '/requestAnalyze/queryApiStat',
  params,
});

/**
 * 查询接口请求
 * @param {string} params.traceId 非必传 链路id
 * @param {string} params.visitorId 非必传 访客id
 * @param {string} params.requestTimeFrom 请求时间自，格式：yyyy-MM-dd HH:mm:ss
 * @param {string} params.requestTimeTo 请求时间止，格式：yyyy-MM-dd HH:mm:ss
 * @param {string} params.serverName 服务名称，如果是查询服务端维度的数据，该字段必传
 * @param {string} params.source 来源，也代表具体某个应用，如果是查询客户端维度的相关数据，该字段必传
 * @param {string} params.env 应用环境
 * @param {string} params.pageSize 应用环境
 * @param {string} params.pageNum 应用环境
 *
 */
export const queryApiRequest = (params) => http.get({
  url: '/requestAnalyze/queryApiRequest',
  params,
});

export const queryTraceInfo = (params) => http.get({
  url: '/traceAnalyze/queryTraceInfo',
  params,
});

/**
 * 查询接口请求数耗时 top
 * @param {string} params.analyzeTimeFrom 分析时间自，格式：yyyy-MM-dd
 * @param {string} params.analyzeTimeTo 分析时间止，格式：yyyy-MM-dd
 * @param {string} params.serverName 服务名称，如果是查询服务端维度的数据，该字段必传
 * @param {string} params.source 来源，也代表具体某个应用，如果是查询客户端维度的相关数据，该字段必传
 * @param {string} params.env 应用环境
 */
export const queryApiRequestCountTop = (params) => http.get({
  url: '/requestAnalyze/queryApiRequestCountTop',
  params,
});

/**
 * 查询接口错误数耗时 top
 * @param {string} params.analyzeTimeFrom 分析时间自，格式：yyyy-MM-dd
 * @param {string} params.analyzeTimeTo 分析时间止，格式：yyyy-MM-dd
 * @param {string} params.serverName 服务名称，如果是查询服务端维度的数据，该字段必传
 * @param {string} params.source 来源，也代表具体某个应用，如果是查询客户端维度的相关数据，该字段必传
 * @param {string} params.env 应用环境
 */
export const queryApiErrorCountTop = (params) => http.get({
  url: '/requestAnalyze/queryApiErrorCountTop',
  params,
});

/**
 * 查询接口平均耗时 top
 * @param {string} params.analyzeTimeFrom 分析时间自，格式：yyyy-MM-dd
 * @param {string} params.analyzeTimeTo 分析时间止，格式：yyyy-MM-dd
 * @param {string} params.serverName 服务名称，如果是查询服务端维度的数据，该字段必传
 * @param {string} params.source 来源，也代表具体某个应用，如果是查询客户端维度的相关数据，该字段必传
 * @param {string} params.env 应用环境
 */
export const queryApiAvgCostTop = (params) => http.get({
  url: '/requestAnalyze/queryApiAvgCostTop',
  params,
});

/**
 * 查询接口请求趋势
 * @param {string} params.uri 接口地址
 * @param {string} params.analyzeTimeFrom 分析时间自，格式：yyyy-MM-dd
 * @param {string} params.analyzeTimeTo 分析时间止，格式：yyyy-MM-dd
 * @param {string} params.serverName 服务名称，如果是查询服务端维度的数据，该字段必传
 * @param {string} params.source 来源，也代表具体某个应用，如果是查询客户端维度的相关数据，该字段必传
 * @param {string} params.env 应用环境
 */
export const queryApiTendency = (params) => http.get({
  url: '/requestAnalyze/queryApiTendency',
  params,
});

/**
 * 查询接口耗时
 * @param {string} params.analyzeTimeFrom 分析时间自，格式：yyyy-MM-dd
 * @param {string} params.analyzeTimeTo 分析时间止，格式：yyyy-MM-dd
 * @param {string} params.serverName 服务名称，如果是查询服务端维度的数据，该字段必传
 * @param {string} params.source 来源，也代表具体某个应用，如果是查询客户端维度的相关数据，该字段必传
 * @param {string} params.env 应用环境，必传
 * @param {string} params.uri 接口地址
 * @param {string} params.bizChannel 业务渠道，必传
 */
export const queryApiCost = (params) => http.get({
  url: '/requestAnalyze/queryApiCost',
  params,
});

/**
 * 查询接口请求来源
 * @param {string} params.analyzeTimeFrom 分析时间自，格式：yyyy-MM-dd
 * @param {string} params.analyzeTimeTo 分析时间止，格式：yyyy-MM-dd
 * @param {string} params.serverName 服务名称，如果是查询服务端维度的数据，该字段必传
 * @param {string} params.source 来源，也代表具体某个应用，如果是查询客户端维度的相关数据，该字段必传
 * @param {string} params.env 应用环境
 */
export const queryApiSource = (params) => http.get({
  url: '/requestAnalyze/queryApiSource',
  params,
// eslint-disable-next-line eol-last
});

/**
 * 查询接口统计

 * @param {string} params.serverName 服务名称，如果是查询服务端维度的数据，该字段必传
 * @param {string} params.uri 接口地址
 * @param {string} params.pageSize 页
 * @param {string} params.pageNum 页码
 */
export const queryApiStatistics = (data) => http.post({
  url: '/uri/statistic/list',
  data,
});

/**
 * 查询接口依赖关系

 * @param {string} params.sourceServerName 来源服务名称
 * @param {string} params.sourceAddress 来源地址
 * @param {string} params.targetServerName 目标服务名称
 * @param {string} params.targetAddress 目标地址
 * @param {string} params.relationModel 依赖模式
 * @param {string} params.pageSize 页
 * @param {string} params.pageNum 页码
 */
export const queryApiDependent = (data) => http.post({
  url: '/server/relation/list',
  data,
});
